import { ICommandsMenu, ICommandsMenuState } from './types';
import { createSelector } from 'reselect';

export const selectLoadedState = (state: ICommandsMenuState) => state.loaded;
export const selectCommandsMenuList = (state: ICommandsMenuState) => state.commandsMenuList;
export const selectSyncError = (state: ICommandsMenuState) => state.error;
export const selectSyncState = (state: ICommandsMenuState) => state.syncing;

export const selectDeletedState = (state: ICommandsMenuState) => state.commandMenuDeleted;

export const selectIndexedCommandsMenuList = createSelector(
  selectCommandsMenuList,
  (commandMenuList) =>
    commandMenuList.reduce((indexed: { [x: string]: any }, commandMenu: ICommandsMenu) => {
      if (commandMenu.menuId) {
        indexed[commandMenu.menuId] = commandMenu;
      }
      return indexed;
    }, {})
);
